<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="4">
              <h1>
                <feather-icon icon="UserIcon" size="30" class="mr-50" />
                Professores
              </h1>
            </b-col>
            <b-col lg="5">
              <b-form @submit.prevent="onSubmitSearch">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filtro.name"
                    placeholder="Buscar Professor"
                    @input="onSearchInput"
                  />
                </b-input-group>
              </b-form>
            </b-col>
            <b-col lg="3" class="text-right">
              <b-button variant="primary button-right" :to="'/ProfessorLista/cadastrar'">
                <feather-icon icon="PlusIcon" class="mr-50" />
                Adicionar Professor
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Filtro por Escola -->
    <b-card class="mb-2">
      <b-row align-v="center">
        <b-col md="4" class="mb-1 mb-md-0">
          <label class="font-small-3 font-weight-bold">Escola</label>
          <v-select
            v-model="filtro.schoolId"
            :options="escolaOptions"
            :reduce="option => option.value"
            label="text"
            placeholder="Todas as escolas"
            @input="onEscolaChange"
          />
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex mb-1" v-if="fetchedUsers?.totalItems">
      <div class="align-self-center text-muted">
        Total: <strong>{{ fetchedUsers.totalItems }}</strong> professor(es)
      </div>
      <b-pagination
        @input="onChangePage"
        class="ml-auto mb-0"
        v-model="currentPage"
        :total-rows="fetchedUsers.totalItems"
        :per-page="perPage"
      ></b-pagination>
    </div>

    <b-card no-body class="mb-0">
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchedUsers?.content"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        no-local-sorting
        @sort-changed="onSortChanged"
        show-empty
        empty-text="Não há professores cadastrados"
      >
        <template #cell(school)="data">
          <span>{{ data.item.school?.name || '-' }}</span>
        </template>
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            
            <b-dropdown-item
              :to="{ name: 'ProfessorEditar', params: { id: data.item.id} }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar Professor</span>
            </b-dropdown-item>

            <b-dropdown-item
              :to="{ name: 'ProfessorTurmas', params: { id: data.item.id} }"
            >
              <feather-icon icon="UsersIcon" />
              <span class="align-middle ml-50">Ver Turmas</span>
            </b-dropdown-item>

            <b-dropdown-divider />

            <b-dropdown-item
              @click="confirmarExclusao(data.item)"
              class="text-danger"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Excluir Professor</span>
            </b-dropdown-item>
          </b-dropdown>

        </template>
      </b-table>
    </b-card>

    <div class="d-flex mt-1" v-if="fetchedUsers?.totalItems">
      <b-pagination
        @input="onChangePage"
        class="ml-auto"
        v-model="currentPage"
        :total-rows="fetchedUsers.totalItems"
        :per-page="perPage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BBadge,
  BLink,
  BMedia,
  BAvatar,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormTextarea,
  BForm,
  BPagination,
} from 'bootstrap-vue'
import { title } from '@/@core/utils/filter'
import { hideSpinner, showSpinner } from '@/services/spinService'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import flatPickr from 'vue-flatpickr-component'
import usersService from '@/services/usersService'
import schoolService from '@/services/schoolService'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BBadge,
    BLink,
    BMedia,
    BAvatar,
    BFormTextarea,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BRow,
    BCol,
    BButton,
    BForm,
    BPagination,
    flatPickr,
    vSelect,
  },
  data: () => ({
    configFlatPickr: { dateFormat: 'd/m/Y', locale: Portuguese },
    filtro: { role: 3, name: '', schoolId: null },
    escolaOptions: [],
    perPage: 10,
    totalUsers: 0,
    currentPage: 1,
    perPageOptions: [10, 25, 50, 100],
    searchQuery: '',
    searchDebounce: null,
    sortBy: 'fullName',
    isSortDirDesc: false,
    roleFilter: null,
    planFilter: null,
    statusFilter: null,
    fetchedUsers: { content: [], totalItems: 0 },
    tableColumns: [
      { key: 'fullName', label: 'Nome', sortable: true },
      { key: 'school', label: 'Escola', sortable: true },
      { key: 'discipline', label: 'Disciplina', sortable: true },
      { key: 'email', label: 'Email', sortable: true },
      { key: 'phone', label: 'Telefone', sortable: true },
      { key: 'actions', label: 'Ações', sortable: false },
    ],
  }),
  mounted() {
    this.carregarEscolas()
    this.fetchUsers()
  },
  methods: {
    async carregarEscolas() {
      try {
        const res = await schoolService.getAll({ page: 1, itemsPerPage: 1000 })
        const list = res.content || res || []
        this.escolaOptions = list
          .map(e => ({ value: e.id, text: e.name }))
          .sort((a, b) => (a.text || '').localeCompare(b.text || '', 'pt-BR'))
      } catch (error) {
        console.error('Erro ao carregar escolas:', error)
      }
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.isSortDirDesc = ctx.sortDesc
      this.currentPage = 1
      this.fetchUsers()
    },
    onEscolaChange() {
      this.currentPage = 1
      this.fetchUsers()
    },
    prepareRequest(obj) {
      const copy = { ...obj }
      if (copy.createdAtTo)
        copy.createdAtTo = copy.createdAtTo
          ? `${copy.createdAtTo.split('/').reverse().join('-')} 00:00`
          : ''
      return {
        ...copy,
        page: this.currentPage,
        itemsPerPage: this.perPage,
        orderBy: this.sortBy ? `${this.sortBy} ${this.isSortDirDesc ? 'desc' : 'asc'}` : undefined,
        schoolId: this.filtro.schoolId || undefined,
      }
    },
    async fetchUsers() {
      showSpinner()
      try {
        this.fetchedUsers = await usersService.getAll(
          this.prepareRequest(this.filtro)
        )
      } catch (error) {
        console.error('Erro ao carregar professores:', error)
      } finally {
        hideSpinner()
      }
    },
    onChangePage() {
      this.fetchUsers()
    },
    onSearchInput() {
      clearTimeout(this.searchDebounce)
      this.searchDebounce = setTimeout(() => {
        this.currentPage = 1
        this.fetchUsers()
      }, 400)
    },
    onSubmitSearch() {
      clearTimeout(this.searchDebounce)
      this.currentPage = 1
      this.fetchUsers()
    },
    // resolveUserRoleVariant: role => {
    //   if (role === 'paciente') return 'primary'
    //   if (role === 'author') return 'warning'
    //   if (role === 'maintainer') return 'success'
    //   if (role === 'editor') return 'info'
    //   if (role === 'admin') return 'danger'
    //   return 'primary'
    // },
    // resolveUserRoleIcon: role => {
    //   if (role === 'paciente') return 'UserIcon'
    //   if (role === 'author') return 'SettingsIcon'
    //   if (role === 'maintainer') return 'DatabaseIcon'
    //   if (role === 'editor') return 'Edit2Icon'
    //   if (role === 'admin') return 'ServerIcon'
    //   return 'UserIcon'
    // },
    resolveUserStatusText: status => {
      if (status === 'abandono') return 'warning'
      if (status === 'ACTIVE') return 'ativo'
      if (status === 'alta') return 'primary'
      if (status === 'óbito') return 'danger'
      return ''
    },

    resolveUserStatusVariant: status => {
      if (status === 'abandono') return 'warning'
      if (status === 'ACTIVE') return 'success'
      if (status === 'alta') return 'primary'
      if (status === 'óbito') return 'danger'
      return 'primary'
    },

    confirmarExclusao(professor) {
      this.$swal({
        title: 'Confirmar Exclusão',
        text: `Tem certeza que deseja excluir o professor "${professor.fullName}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.excluirProfessor(professor.id)
        }
      })
    },

    async excluirProfessor(id) {
      try {
        showSpinner()
        await usersService.deleteProfessor(id)
        this.$swal({
          title: 'Excluído!',
          text: 'Professor excluído com sucesso.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        })
        await this.fetchUsers()
      } catch (error) {
        console.error('Erro ao excluir professor:', error)
        this.$swal({
          title: 'Erro!',
          text: 'Não foi possível excluir o professor. Tente novamente.',
          icon: 'error',
        })
      } finally {
        hideSpinner()
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
